module.exports = "<mat-toolbar>\n    <span [hidden]=\"equities.length > 0\" class=\"equity-bar-element\">No equities</span>\n    <span *ngFor=\"let equity of equities\" class=\"equity-bar-element\">{{ equity.symbol }}: {{ equity.currentValue | currency }}<span [ngClass]=\"equity.diff > 0 ? 'gain' : 'loss'\"> ({{ equity.diffPercent | percent: '1.1-3' }})</span></span>\n</mat-toolbar>\n"


//////////////////
// WEBPACK FOOTER
// /Users/thibautjacob/Documents/Projects/Portfolio/src/app/components/equities-bar/equities-bar.component.html
// module id = ../../../../../src/app/components/equities-bar/equities-bar.component.html
// module chunks = main